<template>
  <div v-if="content && content.list.length > 0">
    <h3 v-if="content.title" class="commonHeadingGrayBorder"><icon :fas="icon.fas" :far="icon.far" class="marginR2" />{{ content.title }}</h3>
    <ul class="linkList">
      <li v-for="(listItem, i) in content.list" :key="i" :class="{ 'linkList-item': inline }">
        <custom-nuxt-link v-if="listItem.link" :to="listItem.link" class="linkList-item-link">{{ listItem.name }}</custom-nuxt-link>
        <p v-else-if="showEmptyLinkAsText">{{ listItem.name }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: Object, required: false, default: () => ({ fas: 'fa-search' }) },
    content: { type: Object, required: false, default: null },
    showEmptyLinkAsText: { type: Boolean, required: false, default: true },
    inline: { type: Boolean, required: false, default: true }
  }
}
</script>
<style scoped lang="scss">
.linkList {
  margin-bottom: 1.5rem;
  &-item {
    display: inline-block;
    margin: 0 0.4em;
  }
  &.wrap {
    line-height: 1.7;
    .linkList-item {
      display: block;
    }
  }
}
</style>
